module.exports = __webpack_public_path__ + "img/app_logo(2).b2e92f71.svg";